import * as React from 'react';
import { IconButtonContext } from '../../icon-button';
import { InputAdornment } from '../input-adornment';
var iconButtonContext = {
    edge: 'end',
};
export var InputActions = function (_a) {
    var actions = _a.actions, multiline = _a.multiline;
    if (!actions || !actions.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, actions.map(function (action, index) {
        if (!action) {
            return null;
        }
        return (React.createElement(InputAdornment, { align: multiline ? 'top' : undefined, position: "end", key: index },
            React.createElement(IconButtonContext.Provider, { value: iconButtonContext }, action)));
    })));
};
